import { InjectionKey, Ref } from 'vue';
import { Router } from 'vue-router';
import Api from '@/classes/Api';
import Auth from '@/classes/Auth';
import Broadcast from '@/classes/Broadcast';
import DocumentDownloader from '@/classes/DocumentDownloader.ts';
import { ModalPluginType } from '@/plugins/modalPlugin.ts';
import { PageProperties } from '@/types/page-properties.type.ts';

export const ApiKey: InjectionKey<Api> = Symbol('$Api');
export const AuthKey: InjectionKey<Auth> = Symbol('$Auth');
export const BroadcastKey: InjectionKey<Broadcast> = Symbol('$Broadcast');
export const RouterKey: InjectionKey<Router> = Symbol('$Router');
export const ModalKey: InjectionKey<ModalPluginType> = Symbol('$Modal');

export const DocumentDownloaderKey: InjectionKey<DocumentDownloader> = Symbol('$DocumentDownloader');
export const PagePropertiesKey: InjectionKey<Ref<PageProperties>> = Symbol('$PageProperties');
